import React from 'react';
import '../Cards/Cards.css';
import CardItem from '../Cards/CardItem';
import AyoDonasi from '../Cards/CardsImages/donasi.png'
import BukaDonasi from '../Cards/CardsImages/bukadonasi.png'
import { Link } from 'react-router-dom';
import Feature1 from '../Cards/CardsImages/feature_1.png'
import Feature2 from '../Cards/CardsImages/feature_2.png'
import Feature3 from '../Cards/CardsImages/feature_3.png'
import Feature4 from '../Cards/CardsImages/feature_4.png'
import './styles/cardsuser.css'
import Carousel1 from '../Urgent/Urgent';
import Carousel2 from '../NewDonation/newdonation';


const CardsUser = () => {
    return (
        <div>
            <div className="Cards1">
                <h6 className="cards-user-txt">Mari Berbagi dengan mereka yang membutuhkan</h6>
                <div className='cards'>
                    <div className='cards__container'>
                        <div className='cards__wrapper'>
                            <ul className='cards__items'>
                                <CardItem
                                    src={AyoDonasi}
                                    text='Kamu bisa mulai donasi di sini'
                                    label='Donasi'
                                    path="/ayo-donasi"
                                />
                                <CardItem
                                    src={BukaDonasi}
                                    text='Galang dana untuk mereka yang membutuhkan bantuan'
                                    label='Buka donasi'
                                    path="/buka-donasi"
                                />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="line-user-page" />
            <div className="Cards2">
                <h6 className="cards-user-txt">Kategori Donasi</h6>
                <div className='cards'>
                    {/* <h1>Kategori Donasi</h1> */}
                    <div className='cards__container'>
                        <div className='cards__wrapper' >
                            <ul className='cards__items'>
                            </ul>
                            <ul className='cards__items'>
                                <CardItem
                                    src={Feature1}
                                    text='Bantu saudara-saudara yang tengah mengalami kesulitan'
                                    label='Kemanusiaan'
                                    path='/kategori-kemanusiaan'
                                />
                                <CardItem
                                    src={Feature3}
                                    text='Demi generasi penerus yang lebih maju'
                                    label='Pendidikan'
                                    path='/kategori-pendidikan'
                                />
                                <CardItem
                                    src={Feature2}
                                    text='Sehatlah negeriku'
                                    label='Kesehatan'
                                    path='/kategori-kesehatan'
                                />
                                <CardItem
                                    src={Feature4}
                                    text='Ulurkan tangan untuk anak-anak yang kurang beruntung'
                                    label='Anak'
                                    path='/kategori-anak'
                                />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="line-user-page" />
            <div className="Carousel1">
                <h6 className="cards-user-txt">Butuh bantuan segera</h6>
                <Carousel1 />
                <button className="carousel-btn">
                    <Link to="/semua-donasi-urgent">
                        Lihat Semua
                    </Link>
                </button>
            </div>
            <hr className="line-user-page" />
            <div className="Carousel2">
                <h6 className="cards-user-txt">Butuh donasi terbaru</h6>
                <Carousel2 />
                <button className="carousel-btn">
                    <Link to="/semua-donasi-terbaru">
                        Lihat Semua
                    </Link>
                </button>
            </div>
        </div>
    )
}

export default CardsUser;